import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import CampaignsServices from "./campaigns.services";

toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: "toast-top-right",
    preventDuplicates: false,
    onclick: null,
    showDuration: "300",
    hideDuration: "1000",
    timeOut: "5000",
    extendedTimeOut: "1000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
};

export const getCampaigns = filters => async (dispatch) => {
    try {
        dispatch({
            type: actions.LOADER_CAMPAIGNS,
            payload: true,
        });
        const resp = await CampaignsServices.getCampaigns(filters);
        dispatch({
            type: actions.GET_CAMPAIGNS,
            payload: resp.data,
        });
        dispatch({
            type: actions.CAMPAIGNS_FAIL,
            payload: null,
        });
    } catch (ex) {
        let message = null;
        if (axios.isAxiosError(ex)) {
            if (ex.response?.status) {
                switch (ex.response.status) {
                    case 400:
                        message = ex.response.data.mensaje;
                        break;
                    case 404:
                        if (ex.response.data && ex.response.data.mensaje) {
                            message = ex.response.data.mensaje;
                        } else {
                            message = messages.notFound;
                        }
                        break;
                    case 403:
                        if (ex.response.data && ex.response.data.detail) {
                            message = ex.response.data.detail;
                        } else {
                            message = messages.notFound;
                        }
                        break;
                    default:
                        message = messages.errorMessage;
                        break;
                }
            } else {
                message = messages.networkError;
            }
        } else {
            message = messages.applicationError
        }
        dispatch({
            type: actions.CAMPAIGNS_FAIL,
            payload: message
        })
    } finally {
        dispatch({
            type: actions.LOADER_CAMPAIGNS,
            payload: false,
        });
    }
}

export const deleteCampaigns = (id, index) => async (dispatch, getState) => {
    try {
        dispatch({
            type: actions.LOADER_CAMPAIGNS,
            payload: true,
        });
        await CampaignsServices.deleteCampaigns(id);
        const { data, count } = getState().campaigns.campaigns;
        let _data = data.slice();
        _data.splice(index, 1);
        dispatch({
            type: actions.GET_CAMPAIGNS,
            payload: {
                data: _data,
                count: count - 1
            },
        });
        dispatch({
            type: actions.CAMPAIGNS_FAIL,
            payload: '',
        });
        toastr.success(messages.successMessage, "", {
            progressBar: true,
            rtl: true,
        });
    } catch (ex) {
        let message = null;
        if (axios.isAxiosError(ex)) {
            if (ex.response?.status) {
                switch (ex.response.status) {
                    case 400:
                        message = ex.response.data.mensaje;
                        break;
                    case 404:
                        if (ex.response.data && ex.response.data.mensaje) {
                            message = ex.response.data.mensaje;
                        } else {
                            message = messages.notFound;
                        }
                        break;
                    default:
                        message = messages.errorMessage;
                        break;
                }
            } else {
                message = messages.networkError;
            }
        } else {
            message = messages.applicationError
        }
        dispatch({
            type: actions.CAMPAIGNS_FAIL,
            payload: message
        })
    } finally {
        dispatch({
            type: actions.LOADER_CAMPAIGNS,
            payload: false,
        });
    }
}

export const editCampaigns = (req, index, setShowModal) => async (dispatch, getState) => {
    try {
        dispatch({
            type: actions.LOADER_CAMPAIGNS,
            payload: true,
        });
        const resp = await CampaignsServices.editCampaigns(req.id, req);
        const { data, count } = getState().campaigns.campaigns;
        let _data = data.slice();
        _data[index] = resp.data;
        dispatch({
            type: actions.GET_CAMPAIGNS,
            payload: {
                data: _data,
                count: count,
            },
        });
        dispatch({
            type: actions.FORM_CAMPAIGNS_FAIL,
            payload: "",
        });
        setShowModal(false)
        toastr.success(messages.successMessage, "", {
            progressBar: true,
            rtl: true,
        });

    } catch (ex) {
        let message = null;
        if (axios.isAxiosError(ex)) {
            if (ex.response?.status) {
                switch (ex.response.status) {
                    case 400:
                        message = ex.response.data.mensaje;
                        break;
                    case 404:
                        if (ex.response.data && ex.response.data.mensaje) {
                            message = ex.response.data.mensaje;
                        } else {
                            message = messages.notFound;
                        }
                        break;
                    default:
                        message = messages.errorMessage;
                        break;
                }
            } else {
                message = messages.networkError;
            }
        } else {
            message = messages.applicationError
        }
        dispatch({
            type: actions.CAMPAIGNS_FAIL,
            payload: message
        })
    } finally {
        dispatch({
            type: actions.LOADER_CAMPAIGNS,
            payload: false,
        });
    }
}

export const saveCampaigns = (req, setShowModal) => async (dispatch, getState) => {
    try {
        dispatch({
            type: actions.SAVE_LOADER_CAMPAIGNS,
            payload: true,
        });
        const resp = await CampaignsServices.saveCampaigns(req);
        const { data, count } = getState().campaigns.campaigns;
        dispatch({
            type: actions.GET_CAMPAIGNS,
            payload: {
                count: count + 1,
                data: [...data, resp.data]
            },
        });
        dispatch({
            type: actions.FORM_CAMPAIGNS_FAIL,
            payload: "",
        });
        setShowModal(false)
        toastr.success(messages.successMessage, "", {
            progressBar: true,
            rtl: true,
        });
    } catch (ex) {
        let message = null;
        if (axios.isAxiosError(ex)) {
            if (ex.response?.status) {
                switch (ex.response.status) {
                    case 400:
                        message = ex.response.data;
                        break;
                    case 404:
                        if (ex.response.data && ex.response.data.mensaje) {
                            message = ex.response.data.mensaje;
                        } else {
                            message = messages.notFound;
                        }
                        break;
                    case 500:
                        message = messages.errorMessage + " " + ex.response.statusText;
                        break;
                    case 403:
                        if (ex.response.data && ex.response.data.detail) {
                            message = ex.response.data.detail;
                        } else {
                            message = messages.notFound;
                        }
                        break;
                    default:
                        message = ex.response.data;
                        break;
                }
            } else {
                message =
                    ex.message === "Network Error" ? messages.networkError : ex.message;
            }
        } else {
            message =
                ex.message === "Network Error" ? messages.networkError : ex.message;
        }
        dispatch({
            type: actions.FORM_CAMPAIGNS_FAIL,
            payload: message,
        });
    } finally {
        dispatch({
            type: actions.SAVE_LOADER_CAMPAIGNS,
            payload: false,
        });
    }
};

export const getTrainingsCalendar = (filters = {}) => async (dispatch) => {
    try {
        dispatch({
            type: actions.LOADER_TRAININGS_CALENDAR,
            payload: true,
        });
        
        const resp = await CampaignsServices.getTrainingsCalendar(filters);
        
        dispatch({
            type: actions.GET_TRAININGS_CALENDAR,
            payload: resp.data,
        });
        
        dispatch({
            type: actions.TRAININGS_CALENDAR_FAIL,
            payload: null,
        });
        
    } catch (ex) {
        let message = null;
        if (axios.isAxiosError(ex)) {
            if (ex.response?.status) {
                switch (ex.response.status) {
                    case 400:
                        message = ex.response.data.mensaje || ex.response.data.detail;
                        break;
                    case 404:
                        message = ex.response.data?.mensaje || messages.notFound;
                        break;
                    case 403:
                        message = ex.response.data?.detail || messages.forbidden;
                        break;
                    default:
                        message = messages.errorMessage;
                        break;
                }
            } else {
                message = messages.networkError;
            }
        } else {
            message = messages.applicationError;
        }
        
        dispatch({
            type: actions.TRAININGS_CALENDAR_FAIL,
            payload: message
        });
        
        toastr.error(message, "", {
            progressBar: true,
            rtl: true,
        });
        
    } finally {
        dispatch({
            type: actions.LOADER_TRAININGS_CALENDAR,
            payload: false,
        });
    }
};

export const getTrainingsEmployeesCalendar = (filters = {}) => async (dispatch) => {
    try {
        dispatch({
            type: actions.LOADER_TRAININGS_EMPLOYEES_CALENDAR,
            payload: true,
        });
        
        const resp = await CampaignsServices.getTrainingsEmployeesCalendar(filters);
        
        dispatch({
            type: actions.GET_TRAININGS_EMPLOYEES_CALENDAR,
            payload: resp.data,
        });
        
        dispatch({
            type: actions.TRAININGS_EMPLOYEES_CALENDAR_FAIL,
            payload: null,
        });
        
    } catch (ex) {
        let message = null;
        if (axios.isAxiosError(ex)) {
            if (ex.response?.status) {
                switch (ex.response.status) {
                    case 400:
                        message = ex.response.data.mensaje || ex.response.data.detail;
                        break;
                    case 404:
                        message = ex.response.data?.mensaje || messages.notFound;
                        break;
                    case 403:
                        message = ex.response.data?.detail || messages.forbidden;
                        break;
                    default:
                        message = messages.errorMessage;
                        break;
                }
            } else {
                message = messages.networkError;
            }
        } else {
            message = messages.applicationError;
        }
        
        dispatch({
            type: actions.TRAININGS_EMPLOYEES_CALENDAR_FAIL,
            payload: message
        });
        
        toastr.error(message, "", {
            progressBar: true,
            rtl: true,
        });
        
    } finally {
        dispatch({
            type: actions.LOADER_TRAININGS_EMPLOYEES_CALENDAR,
            payload: false,
        });
    }
};